import { useTranslation } from "react-i18next";
import { useLocalStorage } from "./useLocalStorage";
import { useEffect, useMemo } from "react";

const useLanguage = () => {
    const { i18n } = useTranslation();

    const [langStorage, setLangStorage] = useLocalStorage('lang')

    const changeLanguage = async (lang) => {
        await i18n.changeLanguage(lang);
        setLangStorage(lang)
    };

    useEffect(() => {
        langStorage && changeLanguage(langStorage)
    }, [langStorage])

    return useMemo(() => ({
        language: i18n.language,
        setLanguage: changeLanguage
    }), [changeLanguage, i18n.language])
}

export default useLanguage